const MAX_OPS_RETRIES = 5;

export const MAX_PUBLIC_ID_RETRIES = MAX_OPS_RETRIES;
export const MAX_RECOVERY_TOKEN_CREATE_RETRIES = MAX_OPS_RETRIES;

/** Maximum slider weight a participant can assign to a single budget function. */
export const MAX_ALLOCATION_WEIGHT = 20;
